/*eslint-disable */

const addRemoveMembersToOperations = (groupDTO, selectedMembers) => {
    const removeMembersOperation = {
        "op": "remove",
        "path": "user",
        "value": selectedMembers,
      }
      groupDTO.operations.push(removeMembersOperation);
}

export const makeEditGroupDTO = (selectedMembers=[]) => {
    const groupDTO = {
        schemas: "urn:ietf:params:scim:api:messages:2.0:PatchOp",
        operations: [],
      };
      addRemoveMembersToOperations(groupDTO, selectedMembers);
      return groupDTO;
}